module.exports = __webpack_public_path__ + "static/media/SherlockB.4d7b532e.png";